import { forwardRef, PropsWithChildren } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Suggestion.scss';

type Props = Readonly<{
  id?: string;
  href: string;
  ariaSelected: boolean;
  ariaDescribedBy?: string;
  tabIndex?: number;
  onKeyDown?: (e: React.KeyboardEvent) => void;
  onClick?: () => void;
}>;

const Suggestion = forwardRef<HTMLAnchorElement, PropsWithChildren<Props>>(
  (
    {
      id,
      href,
      ariaSelected,
      ariaDescribedBy,
      tabIndex = -1,
      onKeyDown,
      onClick,
      children,
    }: PropsWithChildren<Props>,
    ref,
  ) => {
    const navigate = useNavigate();

    const handleKeyDown = (e: React.KeyboardEvent) => {
      if (e.key === 'Enter') {
        navigate(href, {
          replace: true,
        });
      }
      if (onKeyDown) {
        onKeyDown(e);
      }
    };

    return (
      // eslint-disable-next-line jsx-a11y/prefer-tag-over-role -- custom implementation
      <Link
        ref={ref}
        id={id}
        role='option'
        tabIndex={tabIndex}
        aria-selected={ariaSelected}
        aria-describedby={ariaDescribedBy}
        className='suggestion text-body text-decoration-none'
        to={href}
        onKeyDown={handleKeyDown}
        onClick={onClick}>
        {children}
      </Link>
    );
  },
);

export default Suggestion;
